__turbopack_context__.v({
  "header": "Encyclopedia-module-scss-module__uD4ufW__header",
  "header-content": "Encyclopedia-module-scss-module__uD4ufW__header-content",
});
